






















/* eslint-disable @typescript-eslint/camelcase */
import { Component, Prop, Vue } from 'vue-property-decorator'
import AppFormTable from '@core/components/AppFormTable.vue'
import { ClientPolicyDto } from '../../api'
import { TableFormStructure } from '@master/model/structure/FormStructure'
import { UIService } from '@core/services/UIService'
import { inject } from 'inversify-props'
import { SharedVariable } from '@core/model/SharedVariable'
import { options } from '@core/model/UIOptions'

@Component({
  components: {
    AppFormTable
  }
})
export default class ILPSection extends Vue {
  @Prop({ default: () => [] }) private subPolicies: ClientPolicyDto[]
  @Prop({ default: () => [] }) private productOptions: options[]
  @Prop({ default: () => [] }) frequencyOptions: options[]

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  get isDisabled () {
    return true
  }

  get isOpsStaff () {
    // @TODO: To remove away so that it does not have anything to do with store
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get premiumTableStructure (): TableFormStructure<ClientPolicyDto> {
    return [
      {
        label: 'Fund Name',
        key: 'productOid',
        type: 'dropdown',
        options: [
          { label: '', value: '' },
          ...this.productOptions
        ],
        disabled: this.isDisabled
      },
      {
        label: 'Investment Amount ($)',
        type: 'currency',
        model: {
          get: (idx) => this.subPolicies[idx].productMetadata?.investmentAmount,
          set: () => {
            // intentionally left blank
          }
        },
        disabled: this.isDisabled
      },
      {
        label: 'Frequency',
        type: 'dropdown',
        model: {
          get: (idx) => this.subPolicies[idx].productMetadata?.frequency,
          set: () => {
            // intentionally left blank
          }
        },
        options: this.frequencyOptions,
        disabled: this.isDisabled
      },
      {
        label: 'Approved Date',
        key: 'startDate',
        type: 'date',
        disabled: this.isDisabled
      },
      {
        label: 'End Date',
        key: 'endDate',
        type: 'date',
        disabled: this.isDisabled
      }
    ]
  }

  addIlp () {
    this.$emit('ilp-policy-add')
  }

  policyClicked (index: number) {
    this.$emit('ilp-policy-clicked', this.subPolicies[index])
  }

  async removeIlp (idx: number) {
    const isConfirm = await this.uiService.confirm.show({
      type: 'success',
      message: 'Are you sure to delete the selected ILP?'
    }) as boolean

    if (isConfirm) {
      this.$emit('ilp-policy-remove', this.subPolicies[idx].oid)
    }
  }

  mounted () {
    this.uiService = this.sharedVariable.uiService
  }
}
